// extracted by mini-css-extract-plugin
module.exports = {"VideoCallPage":"VideoCallPage_VideoCallPage__1W0Nt"};